export default "__VITE_ASSET__DCVa0IxN__"